import React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-cycle
import { Social } from '../layout/MainLayout';
import LogoFooter from '../../assets/images/logo-footer.svg';
import * as routes from '../../routes';
import { Link } from 'react-router-dom';

const Root = styled.div`
  background: ${({ theme }) => theme.palette.background.contrast};
  padding-bottom: 30px;
`;
const Container = styled.div`
  max-width: 1080px;
  margin: auto;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 60px;
  padding-bottom: 40px;
  @media (max-width: 768px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;
const BottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 32px;
  padding-bottom: 15px;
  font-size: 15px;
  /* color: ${({ theme }) => theme.palette.text.secondary}; */
  color: #7b88a8;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  @media (max-width: 768px) {
    flex-direction: column;
    & > p {
      margin-bottom: 13px;
    }
  }
`;
const Logo = styled.img`
  width: 80px;
  height: 80px;
  margin-right: 20%;
  @media (max-width: 768px) {
    display: none;
  }
`;
const ListLink = styled.ul`
  color: ${({ theme }) => theme.palette.text.white};
  display: flex;
  flex: 1 1 24%;
  max-width: 24%;
  padding: 0;
  flex-direction: column;
  @media (max-width: 768px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
  li {
    margin-top: 4px;
    margin-bottom: 8px;
    padding-top: 8px;
    padding-right: 6px;
    padding-bottom: 8px;
    @media (max-width: 768px) {
      text-align: center;
    }
  }
`;

const PrimaryLinks = [
  { id: 0, title: 'Home', route: routes.home },
  { id: 0, title: 'Work', route: routes.work },
  { id: 0, title: 'About', route: routes.about },
];
const SecondaryLinks = [
  { id: 0, title: 'Blog', route: routes.home },
  { id: 0, title: 'Uses', route: routes.about },
  { id: 0, title: 'About', route: routes.about },
];
const SocialLinks = [
  { id: 0, title: 'GitHub', route: 'https://github.com/paulclindo' },
  { id: 0, title: 'LinkedIn', route: 'https://www.linkedin.com/in/paulccari/' },
  { id: 0, title: 'Twitter', route: 'https://twitter.com/paulclindo' },
  { id: 0, title: 'Instragram', route: 'https://www.instagram.com/in/paulccari/' },
];

const Footer = () => {
  return (
    <Root>
      <Container>
        <Content>
          <Logo src={LogoFooter} alt="" />
          <ListLink>
            {PrimaryLinks.map(({ title, route }) => (
              <li>
                <Link to={route}>{title}</Link>
              </li>
            ))}
          </ListLink>
          <ListLink>
            {SecondaryLinks.map(({ title, route }) => (
              <li>
                <Link to={route}>{title}</Link>
              </li>
            ))}
          </ListLink>
          <ListLink>
            {SocialLinks.map(({ title, route }) => (
              <li>
                <a href={route} target="_blank" rel="noreferrer">
                  {title}
                </a>
              </li>
            ))}
          </ListLink>
        </Content>
        <BottomBar>
          <p>@ Paul Ccari, 2021. All Rights Reserved.</p>
          <Social footer />
        </BottomBar>
      </Container>
    </Root>
  );
};

export default Footer;
